import { Injectable } from '@angular/core';
import { filter, map, Observable, of, take } from 'rxjs';
import { UserRole } from '../../interfaces/user.interface';
import { PMEUserService } from '../services/pme-user.service';

@Injectable({
  providedIn: 'root'
})
export class DataIntegrityGuard {
  constructor(private pmeUserService: PMEUserService) {}

  canActivate(): Observable<boolean> {
    return this.canAccessDataIntegrity();
  }

  canActivateChild(): Observable<boolean> {
    return this.canAccessDataIntegrity();
  }

  private isDataIntegrityUser(): boolean {
    return this.pmeUserService.currentUser?.roles?.includes(UserRole.PMEDataIntegrity) ?? false;
  }

  private canAccessDataIntegrity(): Observable<boolean> {
    if (this.pmeUserService.currentUser) {
      return of(this.isDataIntegrityUser());
    }

    return this.pmeUserService.currentUserChanged$.pipe(
      filter(() => this.pmeUserService.currentUser !== null),
      take(1),
      map(() => this.isDataIntegrityUser())
    );
  }
}
